export default __webpack_public_path__ + "static/media/sabs-logo-tight.966f2aea.png";